<div class="bonus-topbar tw-p-3 desktop:tw-p-4">
  <div class="bonus-topbar__content-container">
    @if (isCasinoScenario) {
      <img src="../../../assets/images/bonus_spin.svg" class="bonus-topbar__coin spin-icon" />
    } @else if (isGeneralScenario) {
      <img src="../../../assets/images/bonus_coin.svg" class="bonus-topbar__coin" />
    } @else if (
      isSportsbookScenario || isAnyGameFreeBetScenario || isSpecificGamesScenario || isSingleAltenarScenario || isSingleBetbyScenario
    ) {
      <img src="../../../assets/images/free_bet_bonus_header.avif" class="bonus-topbar__coin" />
    }
    <div class="bonus-topbar__text-container !tw-text-[color:var(--text-neutral-primary)]">
      @switch (promotionBonusScenario) {
        @case ('INCLUDING_ALL_MULTI_FREE_BET') {
          <ng-container [ngTemplateOutlet]="freeBetTemplate"></ng-container>
        }
        @case ('EXCLUDING_ALL_FREE_BET') {
          <ng-container [ngTemplateOutlet]="freeBetTemplate"></ng-container>
        }
        @case ('INCLUDING_ONE_FREE_BET') {
          <ng-container [ngTemplateOutlet]="freeBetTemplate"></ng-container>
        }
        @case ('ANY_GAME_FREE_BET') {
          <ng-container [ngTemplateOutlet]="freeBetTemplate"></ng-container>
        }
        @case ('SINGLE_SPORTSBOOK') {
          @if (isSingleFreeBetScenario) {
            <ng-container [ngTemplateOutlet]="freeBetTemplate"></ng-container>
          } @else {
            <div class="bonus-topbar__title">
              {{ bonusAmount | currencycase }} {{ 'GENERAL.AVAILABLE_PLURAL' | translate | lowercase }}!
            </div>
          }
        }
        @case ('SINGLE_ALTENAR') {
          <ng-container [ngTemplateOutlet]="freeBetTemplate"></ng-container>
        }
        @case ('SINGLE_BETBY') {
          <ng-container [ngTemplateOutlet]="freeBetTemplate"></ng-container>
        }
        @case ('MULTIPLE_SPORTSBOOK') {
          <ng-container [ngTemplateOutlet]="multipleSbTemplate"></ng-container>
        }
        @case ('SINGLE_GENERAL') {
          <div class="bonus-topbar__title">
            {{ 'PROMOTION_BONUS.NEW_BONUS' | translate }}
          </div>
          <div class="bonus-topbar__subtitle-row">
            <span class="bonus-topbar__label">{{ promotion?.promotion?.friendly_name }}</span>
            <span class="bonus-topbar__amount-badge">
              {{ bonusAmount | currencycase }}
            </span>
          </div>
        }
        @case ('MULTIPLE_GENERAL') {
          <div class="bonus-topbar__title">
            {{ 'PROMOTION_BONUS.NEW_BONUS' | translate }}
          </div>
          <div class="bonus-topbar__subtitle-row">
            <span class="bonus-topbar__amount-badge">
              {{ bonusAmount | currencycase }}
            </span>
            <span class="bonus-topbar__to-bet">{{ 'PROMOTION_BONUS.TO_BET' | translate }}</span>
          </div>
        }
      }

      @if (isCasinoScenario) {
        <div class="bonus-topbar__title">{{ totalRounds }} {{ 'PROMOTION_BONUS.FREE_SPINS' | translate }}!</div>
        <div class="bonus-topbar__subtitle-row">
          @if (isSingleCasinoGame) {
            <span class="bonus-topbar__label">{{ 'PROMOTION_BONUS.PLAY_IN' | translate }} {{ game?.name }}</span>
          }
          @if (!isSingleCasinoGame) {
            <span class="bonus-topbar__label">{{ 'PROMOTION_BONUS.PLAY_IN' | translate }} {{ 'GENERAL.CASINO' | translate }}</span>
          }
        </div>
      }

      @if (isMixedScenario || isMultiFreeBetScenario) {
        <div class="bonus-topbar__title">
          {{ 'PROMOTION_BONUS.VARIOUS_BONUSES_AVAILABLE' | translate }}
        </div>
        <div class="bonus-topbar__label">
          {{ 'PROMOTION_BONUS.CLAIM_NOW_AND_ENJOY' | translate }}
        </div>
      }
    </div>

    <button class="bonus-topbar__claim-button" (click)="onClaim()">
      @if (isSingleFreeBetScenario) {
        <span>{{ 'GENERAL.TO_BET' | translate }}</span>
      } @else if (mustClaim) {
        <span>{{ (isSingleCasinoGame ? 'PROMOTION_BONUS.PLAY' : 'PROMOTION_BONUS.CLAIM') | translate }}</span>
      } @else if (!mustClaim) {
        <span>{{ (totalBonuses === 1 ? 'PROMOTION_BONUS.PLAY' : 'GENERAL.SEE_MORE') | translate }}</span>
      }
    </button>
  </div>

  <app-close-button color="text" (clicked)="onClose()"></app-close-button>
</div>

<ng-template #freeBetTemplate>
  <div
    ltMdClass="tw-text-[12px]"
    class="tw-flex tw-flex-row tw-min-w-0 desktop:tw-items-center max-desktop:tw-flex max-desktop:tw-flex-col"
  >
    <span class="promotion_bonus__title">
      @if (freeBetTitle) {
        {{ freeBetTitle }}
      } @else {
        {{ 'BONUS_TYPES.FREE_BET' | translate }}!
      }
    </span>
    <span class="tw-font-[350] ellipsis_two_lines" matTooltip="{{ freeBetDescription | translate }}"
      >{{ freeBetDescription | translate }}.
    </span>
    <span class="tw-font-[350] ellipsis_two_lines tw-text-[10px]">
      @if (betUntil) {
        {{ 'FREE_BETS.VALID_UNTIL' | translate }} {{ betUntil | date: 'dd/MM/yy HH:mm' }}.
      }
    </span>
  </div>
</ng-template>

<ng-template #multipleSbTemplate>
  <div class="bonus-topbar__title">
    {{ 'PROMOTION_BONUS.NEW_BONUS' | translate }}
  </div>
  <div class="bonus-topbar__subtitle-row">
    <span class="bonus-topbar__label">{{ 'PROMOTION_BONUS.CLAIM_UNTIL' | translate }}</span>
    <span class="bonus-topbar__amount-badge">
      {{ bonusAmount | currencycase }}
    </span>
    <span class="bonus-topbar__to-bet">{{ 'PROMOTION_BONUS.TO_BET' | translate }}</span>
  </div>
</ng-template>
